import { api } from '@/lib/api'

/**
 * @returns {Promise<import('@/types/api').Company>}
 */
export async function fetchCompany() {
  const { data } = await api.get('/admin/company')
  return data.data.company
}

/**
 * @param {Partial<import('@/types/api').Company>} payload
 * @returns {Promise<import('@/types/api').Company>}
 */
export async function updateCompany(payload) {
  const { data } = await api.put('/admin/company', payload)
  return data.data.company
}
